var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute inset-0"},[_c('div',{attrs:{"id":"ruler-right"}}),_vm._v(" "),_c('div',{attrs:{"id":"size-right"}},[_vm._v(_vm._s(_vm.verticalSize))]),_vm._v(" "),_c('div',{attrs:{"id":"ruler-bottom"}}),_vm._v(" "),_c('div',{attrs:{"id":"size-bottom"}},[_vm._v(_vm._s(_vm.horizontalSize))])])
}
var staticRenderFns = []

export { render, staticRenderFns }